<div
    class="flex flex-col px-10 py-4 border-2 border-gray-900/10 rounded-md"
>
    <div class="text-lg font-semibold my-1">
        Dodaj nadređenog
    </div>
    <div class="flex gap-8 items-center">
        <valben-searchable-select
            class="w-full md:w-56"
            placeholder="Odaberi radnika"
            searchPlaceholder="Ime ili mbrad"
            panelWidth="360px"
            [options]="employeeOptions()"
            [value]="selectedSuperiorId()"
            [virtualScroll]="true"
            (valueChange)="setSuperior($event)" />
    </div>
</div>
